<mat-toolbar class="subtitulo">Ações Executadas</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsulta="ngForm">
            <div fxLayout="row">
                <div ngModelGroup="comboAtividade" fxFlex="50">
                    <combo-atividade [desabilitado]="false"
                                     [obrigatorio]="false"
                                     [selecionado]="atividadeFiltro"
                                     (valorChange)="onValorChangeAtividade($event)">
                    </combo-atividade>
                </div>
                <div ngModelGroup="comboAcaoAtividade" fxFlex="49">
                    <combo-acao-atividade
                            [desabilitado]="false"
                            [obrigatorio]="false"
                            [selecionado]="acaoFiltro"
                            (valorChange)="onValorChangeAcao($event)"
                            [idAtividade]="atividadeFiltro?.id">
                    </combo-acao-atividade>
                </div>
            </div>
            <div fxLayout="row" fxFlexFill>
                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="100">
                    <mat-label>Descrição</mat-label>
                    <input matInput maxlength="200" name="descricaoFiltroInput"
                           placeholder="Descrição" [(ngModel)]="descricaoFiltro">
                </mat-form-field>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                 fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">
            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef>Descrição</th>
                <td mat-cell *matCellDef="let element"> {{ element.descricao }}</td>
            </ng-container>
            <ng-container matColumnDef="atividade">
                <th mat-header-cell *matHeaderCellDef>Atividade</th>
                <td mat-cell *matCellDef="let element"> {{ element.acao.oficina.descricao }}</td>
            </ng-container>
            <ng-container matColumnDef="acao">
                <th mat-header-cell *matHeaderCellDef>Ação da Atividade</th>
                <td mat-cell *matCellDef="let element"> {{ element.acao.descricao }}</td>
            </ng-container>
            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações</th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>{{ perfilAcesso.altera ? 'edit' : 'search' }}</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{ msg }}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
             style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova ação executada" mat-fab color="primary"
                        [routerLink]="['/acaoExecutada/cadastrar']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>